import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';
import util from 'preact-util';

configure({ enforceActions: 'always' });

class ElearningLessonStore extends LocalModel {
    constructor() {
        super('elearningLesson', {
            namePlural: 'elearningLessons',
            namePluralReal: 'elearninglessons',
            sort: 'sortOrder',
            limit: 500,
            api: {
                search: {
                    url: '/api/elearninglessons/',
                    params: {
                        limit: 500,
                        sort: 'sortOrder',
                    },
                },
                load: {
                    url: '/api/elearninglessons/',
                    params: {},
                },
                save: {
                    url: '/api/elearninglessons/admin/',
                    params: {},
                },
                delete: {
                    url: '/api/elearninglessons/admin/',
                    params: {},
                },
            },
        });
    }

    @observable newElearningLesson = {};

    @observable elearningLesson = {};

    @observable elearningLessons = [];

    @action
    async loadForCourse(courseId) {
        const response = await util.fetchApi('/api/elearninglessons/', { method: 'GET' }, { course: courseId });
        if (response?.status === 200) {
            this.updateKeyValue('elearningLessons', response.data || []);
        }
        return response;
    }

    /** Admin: pick one lesson from the loaded list into `elearningLesson` for the editor drawer. */
    @action
    setCurrent(lesson) {
        this.updateKeyValue('elearningLesson', lesson || {});
    }
}

const store = new ElearningLessonStore();
export default store;
